// frontend/src/AppRoutes.tsx
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { AppLoadingOrError } from '~m/AppUi/components/AppLoadingOrError.tsx'
import { AuthProvider } from '~m/auth/context/AuthProvider.tsx'
import { FeatureFlagsProvider } from '~m/featureFlags/FeatureFlagsProvider.tsx'
import { OwnPublicProfileProvider } from '~m/profile/context/OwnPublicProfileProvider.tsx'
import { SnackbarProvider } from '@pogokid/mui'
import { lazyWithReload } from '~/lazyWithReload.tsx'

const HomePage = lazyWithReload(() => import('./pages/index'))
const HandlePage = lazyWithReload(
  () => import('./pages/[handle]/index.tsx')
)
const DashboardPage = lazyWithReload(
  () => import('./pages/dashboard')
)
const FaqPage = lazyWithReload(() => import('./pages/faq'))
const GetStartedPage = lazyWithReload(
  () => import('./pages/getstarted')
)
const InvitePage = lazyWithReload(
  () => import('./pages/invite/[id]/index.tsx')
)
const PayPage = lazyWithReload(
  () => import('./pages/pay/[link]/index.tsx')
)
const ContactPortalPage = lazyWithReload(
  () => import('./pages/portal/[token]/index.tsx')
)
const PricingPage = lazyWithReload(
  () => import('./pages/pricing')
)
const SignInPage = lazyWithReload(() => import('./pages/signin'))
const SignOutPage = lazyWithReload(
  () => import('./pages/signout')
)
const AboutPage = lazyWithReload(
  () => import('./pages/about/us')
)
const CareersPage = lazyWithReload(
  () => import('./pages/about/careers')
)
const FoundingMembersPage = lazyWithReload(
  () => import('./pages/founding-members')
)
const DesignSystemPage = lazyWithReload(
  () => import('./pages/design-system')
)
const DesignSystemComponentPage = lazyWithReload(
  () => import('./pages/design-system/[component]/index.tsx')
)

export default function AppRoutes() {
  return (
    <SnackbarProvider>
      <AuthProvider>
        {/* Mounted once for the whole app: each page layout mounts
            its own AppUiProvider, so a provider there would fetch
            again and lose its patch on every navigation. */}
        <OwnPublicProfileProvider>
          <FeatureFlagsProvider>
            <Suspense
              fallback={
                <AppLoadingOrError message="Loading..." />
              }
            >
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route
                  path="dashboard"
                  element={<DashboardPage />}
                />
                <Route
                  path="getstarted"
                  element={<GetStartedPage />}
                />
                <Route path="faq" element={<FaqPage />} />
                <Route
                  path="pricing"
                  element={<PricingPage />}
                />
                <Route path="about/us" element={<AboutPage />} />
                <Route
                  path="about/careers"
                  element={<CareersPage />}
                />
                <Route
                  path="founding-members"
                  element={<FoundingMembersPage />}
                />
                <Route path="signin" element={<SignInPage />} />
                <Route
                  path="signout"
                  element={<SignOutPage />}
                />
                <Route
                  path="invite/:id"
                  element={<InvitePage />}
                />
                <Route path="pay/:link" element={<PayPage />} />
                <Route
                  path="portal/:token"
                  element={<ContactPortalPage />}
                />
                <Route path="design-system">
                  <Route index element={<DesignSystemPage />} />
                  <Route
                    path=":component"
                    element={<DesignSystemComponentPage />}
                  />
                </Route>
                <Route path=":handle/*">
                  <Route path="*" element={<HandlePage />} />
                </Route>
              </Routes>
            </Suspense>
          </FeatureFlagsProvider>
        </OwnPublicProfileProvider>
      </AuthProvider>
    </SnackbarProvider>
  )
}
